// Shared club-logo URL resolution for the portal. Both the directory list
// (Landing) and the map tooltip (PortalMap) resolve logos the same way, so the
// legacy-CDN path and the cdnBase rule live here in one place.
import { config } from '@/config';
import type { OrgDirectoryResult } from './api';

// Legacy platform CDN — club logos live at /0/clublogo/<ClubId>_<size>.webp
// (M = medium). Distinct from our own cdnBase. We build the URL client-side and
// fall back to a monogram when the legacy club never uploaded a logo (the img
// 404s and the caller swaps in the monogram).
const LEGACY_CDN_BASE = 'https://cdn.sportadmin.se';

export function legacyLogoUrl(clubId: number): string {
  return `${LEGACY_CDN_BASE}/0/clublogo/${clubId}_M.webp`;
}

// resolveLogo resolves a result's logo URL. Go orgs resolve their uploaded
// logo_object_key through cdnBase; legacy orgs build a URL against the legacy
// CDN from their club id. Returns null when there's nothing to show — the
// caller renders a Monogram placeholder.
export function resolveLogo(org: OrgDirectoryResult): string | null {
  if (org.source === 'legacy') {
    return org.legacy_club_id != null ? legacyLogoUrl(org.legacy_club_id) : null;
  }
  if (org.logo_object_key) return `${config.cdnBase}/${org.logo_object_key}`;
  return null;
}
